// Fonction pour obtenir le panier actuel
function getCart() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(data => data);
}

// Fonction pour vérifier la présence d'une variante dans le panier et obtenir la quantité
function checkVariantInCart(cart, variantId) {
let itemInCart = cart.items.find(item => item.variant_id === variantId);
if (itemInCart) {
    return itemInCart.quantity;
} else {
    return 0; // La variante n'est pas dans le panier
}
}

function findParentWithClass(element, className) {
while (element && element !== document) {
    if (element.classList.contains(className)) {
        return element;
    }
    element = element.parentNode;
}
return null;
}

async function setQuantity (cart){
const selectQuantity = document.getElementsByClassName('quantity__input')[0];
if(selectQuantity){
  const el = document.getElementById('minimumStock')
  const minimumRequired = el.dataset.min
  const select = document.getElementsByClassName('select__select')[0];
  const selectedIndex = select.selectedIndex;
  const selectedOption = select.options[selectedIndex];
  const variantId = selectedOption.dataset.variantId
  const availableQuantity = selectedOption.dataset.availableQuantity
  let quantityInCart = 0;
  getCart().then(cart => {
    for (let index = 0; index < cart.items.length; index++) {
      const element = cart.items[index];
      if(element.id == variantId){
        quantityInCart = element.quantity;
      }
    }
    const totalAvailable = availableQuantity - quantityInCart - minimumRequired;
    selectQuantity.max = totalAvailable;
  })
}
}

function watchQuantity(){
const selects = document.querySelectorAll('.select__select')
selects.forEach(function(select) {
  console.log(select.options[select.selectedIndex])
  setHowAvailable(select)
  select.addEventListener('change', function(event) {
      setQuantity()
      setHowAvailable(select)
      const selectedOption = select.options[select.selectedIndex];
      console.log(selectedOption)
  });
});
}

function setHowAvailable(select){
  const minimumToOrder = document.getElementById('minimumStock')
  let minimumRequired = minimumToOrder.dataset.min
  if(minimumRequired > 0){
    minimumRequired = minimumRequired - 1
  }
  const selectedOption = select.options[select.selectedIndex];
  const totalAvailable = selectedOption.dataset.availableQuantity - minimumRequired;
  const productLowStockQuantity = document.getElementById('productLowStockQuantity').dataset.productLowStockQuantity;
  console.log(totalAvailable)
  if(totalAvailable <= productLowStockQuantity){
    const howAvailableDiv = document.querySelector('.how-available')
    howAvailableDiv.classList.remove('d-none')
    const howAvailable = document.querySelector('.how-available-number')
    howAvailable.textContent = totalAvailable
    return totalAvailable;
  } else {
    const howAvailableDiv = document.querySelector('.how-available-div')
    howAvailableDiv.classList.add('d-none')
  }
}

// Fonction pour initialiser la vérification des variantes
function initializeVariantCheck(clicked) {
  // const el = document.getElementById('minimumStock')
  // const inputHidden = document.querySelector('input[name="id"]');
  // if(clicked != null){
  //   const card = findParentWithClass(clicked, 'grid__item')
  //   const content = card.getElementsByClassName('quick-add-size')
  //   content[0].classList.add('loading')
  // }
  // const minimumRequired = el.dataset.min
  // getCart().then(cart => {
  //     const quickOrProduct = document.getElementsByClassName('quick-add-size')
  //     //Check pour savoir ou on est pour appliquer le correctif sur l'ajout rapide ou sur le select de taille sur la page produit
  //     if(quickOrProduct[0] === undefined){
  //       const variantElements = document.querySelectorAll('.product-variant'); // Ajustez ce sélecteur selon votre HTML
  //       let areAllNull = true;
  //       variantElements.forEach(variantElement => {
  //           const variantId = parseInt(variantElement.dataset.variantId, 10); // Supposons que chaque élément de variante a un data-attribute data-variant-id
  //           const availableQuantity = parseInt(variantElement.dataset.availableQuantity, 10); // Supposons que chaque élément de variante a un data-attribute data-available-quantity

  //           const quantityInCart = checkVariantInCart(cart, variantId);
  //           if ((availableQuantity - quantityInCart) <= minimumRequired) {
  //               variantElement.disabled = true;
  //               variantElement.removeAttribute('selected');
  //           } else {
  //               if (areAllNull === true) {
  //                 variantElement.setAttribute('selected', 'selected');
  //                 var currentUrl = new URL(window.location.href);
  //                 currentUrl.searchParams.set('variant', variantId);
  //                 history.replaceState(null, '', currentUrl);
  //                 inputHidden.value = variantId
  //               }
  //               areAllNull = false;
  //           }
  //       });

  //       if (areAllNull) {
  //           const select = document.querySelector('.select__select');
  //           const option = document.createElement('option');
  //           option.text = window.translations.emptyMessage;
  //           option.selected = true;
  //           option.disabled = true;
  //           select.add(option);
  //           const btn = document.getElementsByClassName('product-form__submit')
  //           btn[0].disabled = true
  //       }
  //     } else {
  //       if(clicked !== null){
  //         const card = findParentWithClass(clicked, 'grid__item')
  //         const content = card.getElementsByClassName('quick-add-size')
  //         content[0].classList.remove('loading')
  //         const variantElements = card.querySelectorAll('.quick-add-size__size'); // Ajustez ce sélecteur selon votre HTML

  //         variantElements.forEach(variantElement => {
  //             const variantId = parseInt(variantElement.dataset.variantId, 10); // Supposons que chaque élément de variante a un data-attribute data-variant-id
  //             const availableQuantity = parseInt(variantElement.dataset.availableQuantity, 10); // Supposons que chaque élément de variante a un data-attribute data-available-quantity
  //             const quantityInCart = checkVariantInCart(cart, variantId);
  //             if ((availableQuantity - quantityInCart) <= minimumRequired) {
  //                 variantElement.disabled = true;
  //                 variantElement.classList.add('sold-out')
  //             }
  //         });
  //       }
  //     }
  //     setQuantity(cart)
  // });
}